import { render, staticRenderFns } from "./DepartmentsDaily.vue?vue&type=template&id=5c3d4cca&"
import script from "./DepartmentsDaily.vue?vue&type=script&lang=ts&"
export * from "./DepartmentsDaily.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports